

// import React, { useContext, useEffect, useState } from "react";
// import * as XLSX from "xlsx";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
// import Application from "../../../StateContext/Application.js";
// import { ProposalCreation32 } from "../../../../../public/LoginImages/importimages.js";
// import { submit } from "../../../../../public/LoginImages/importimages.js";
// import GooglePagination from "../../../styles/GooglePagination";
// import { useLanguage } from "../../../../../lang/langcontext/LanguageContext.js";

// const GR_EXPECTED_COLUMNS = [
//   "Sr. No.",
//   "Administrative Approved Year",
//   "District",
//   "Taluka",
//   "Work Name",
//   "Class Of Work",
//   "Work Amount",
//   "Job ID",
//   "GR Date",
//   "GR Number",
//   "Head Code",
//   "Constituency Name",
//   "Multiple Gram Panchayat?",
//   "Type of Work",
//   "Road Category",
//   "Road Number",
//   "Proposed Length (KM)",
//   "Gram Panchayat",
//   "Remark",
//   "Proposal File Number",
//   "Proposal Date",
// ];

// /*
//  * ONLY THESE 9 FIELDS ARE MANDATORY
//  */
// const GR_MANDATORY_COLUMNS = [
//   "GR Number",
//   "Administrative Approved Year",
//   "District",
//   "Taluka",
//   "Work Name",
//   "Class Of Work",
//   "Work Amount",
//   "Job ID",
//   "GR Date",
//   "Head Code",
// ];

// const MONEY_COLUMNS = ["Work Amount"];

// const formatExcelDate = (value) => {
//   if (
//     value === null ||
//     value === undefined ||
//     value === ""
//   ) {
//     return "";
//   }

//   if (typeof value === "number") {
//     const parsed = XLSX.SSF.parse_date_code(value);

//     if (parsed) {
//       const dd = String(parsed.d).padStart(2, "0");
//       const mm = String(parsed.m).padStart(2, "0");
//       const yyyy = parsed.y;

//       return `${yyyy}-${mm}-${dd}`;
//     }
//   }

//   if (
//     value instanceof Date &&
//     !isNaN(value.getTime())
//   ) {
//     const yyyy = value.getFullYear();
//     const mm = String(value.getMonth() + 1).padStart(2, "0");
//     const dd = String(value.getDate()).padStart(2, "0");

//     return `${yyyy}-${mm}-${dd}`;
//   }

//   const str = String(value).trim();

//   // DD-MM-YYYY
//   if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(str)) {
//     const [d, m, y] = str.split("-");

//     return `${y}-${m.padStart(2, "0")}-${d.padStart(
//       2,
//       "0"
//     )}`;
//   }

//   // DD/MM/YYYY
//   if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(str)) {
//     const [d, m, y] = str.split("/");

//     return `${y}-${m.padStart(2, "0")}-${d.padStart(
//       2,
//       "0"
//     )}`;
//   }

//   // YYYY-MM-DD
//   if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
//     return str;
//   }

//   // Excel sometimes gives date strings with time
//   const parsedDate = new Date(str);

//   if (!isNaN(parsedDate.getTime())) {
//     const yyyy = parsedDate.getFullYear();
//     const mm = String(
//       parsedDate.getMonth() + 1
//     ).padStart(2, "0");
//     const dd = String(
//       parsedDate.getDate()
//     ).padStart(2, "0");

//     return `${yyyy}-${mm}-${dd}`;
//   }

//   return str;
// };

// const isValidDate = (value) => {
//   if (!value) return false;

//   const date = new Date(value);

//   return !isNaN(date.getTime());
// };

// const isValidAmount = (value) => {
//   if (
//     value === null ||
//     value === undefined ||
//     String(value).trim() === ""
//   ) {
//     return false;
//   }

//   return /^\d+(\.\d{1,2})?$/.test(
//     String(value).trim()
//   );
// };

// const normalizeGramPanchayat = (value) => {
//   if (Array.isArray(value)) {
//     return value
//       .map((item) => String(item).trim())
//       .filter(Boolean);
//   }

//   if (!value) {
//     return [];
//   }

//   return String(value)
//     .split(",")
//     .map((item) => item.trim())
//     .filter(Boolean);
// };

// const normalizeMultipleGP = (value) => {
//   const str = String(value ?? "")
//     .trim()
//     .toLowerCase();

//   if (
//     str === "yes" ||
//     str === "y" ||
//     str === "true"
//   ) {
//     return "Yes";
//   }

//   if (
//     str === "no" ||
//     str === "n" ||
//     str === "false"
//   ) {
//     return "No";
//   }

//   return String(value ?? "").trim();
// };

// const UploadGRProposalCreation = () => {
//   const operation = useContext(Application);

//   const {
//     GRProposalCreationFunction,
//     Usermenu,
//   } = operation;

//   const { t } = useLanguage();

//   const [tableData, setTableData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [RoleID, setRoleID] = useState(null);

//   const [selectedFile, setSelectedFile] = useState(null);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [showAll, setShowAll] = useState(false);

//   const [uploadError, setUploadError] = useState("");

//   const BILLS_PER_PAGE = showAll
//     ? tableData.length || 1
//     : 10;

//   const totalPages = Math.ceil(
//     tableData.length / BILLS_PER_PAGE
//   );

//   const indexOfLast =
//     currentPage * BILLS_PER_PAGE;

//   const indexOfFirst =
//     indexOfLast - BILLS_PER_PAGE;

//   const currentRows = tableData.slice(
//     indexOfFirst,
//     indexOfLast
//   );

//   /*
//    * ---------------------------------------------------------
//    * GET USER ROLE
//    * ---------------------------------------------------------
//    */

//   const getmenu = async () => {
//     try {
//       const result = await Usermenu();

//       if (
//         !result ||
//         typeof result !== "object"
//       ) {
//         console.error(
//           "Invalid Usermenu response:",
//           result
//         );
//         return;
//       }

//       const roleID = result?.Data?.RoleID;

//       setRoleID(roleID);

//       console.log(
//         "GR Excel Upload RoleID:",
//         roleID
//       );
//     } catch (error) {
//       console.error(
//         "Error fetching user role:",
//         error
//       );
//     }
//   };

//   useEffect(() => {
//     getmenu();
//   }, []);

//   /*
//    * ---------------------------------------------------------
//    * ALLOWED HEAD CODE
//    * ---------------------------------------------------------
//    */

//   const getAllowedHeadCode = () => {
//     if (
//       RoleID === 25 ||
//       RoleID === 24
//     ) {
//       return "3054-2419(Roads and bridge repair maintenance program)";
//     }

//     return "2515-1238(MLA Representative)";
//   };

//   /*
//    * ---------------------------------------------------------
//    * DOWNLOAD SAMPLE EXCEL
//    * ---------------------------------------------------------
//    */

//   const downloadSampleExcel = async () => {
//     try {
//       const workbook =
//         new ExcelJS.Workbook();

//       const worksheet =
//         workbook.addWorksheet(
//           "GR Proposal"
//         );

//       worksheet.columns =
//         GR_EXPECTED_COLUMNS.map(
//           (column) => ({
//             header: column,
//             key: column,
//             width: 25,
//           })
//         );

//       /*
//        * Header formatting
//        */

//       const headerRow =
//         worksheet.getRow(1);

//       headerRow.eachCell((cell) => {
//         cell.font = {
//           bold: true,
//           color: {
//             argb: "00000",
//           },
//         };

//         cell.fill = {
//           type: "pattern",
//           pattern: "solid",
//           fgColor: {
//             argb: "FFFFFF",
//           },
//         };

//         cell.alignment = {
//           vertical: "middle",
//           horizontal: "center",
//           wrapText: true,
//         };
//       });

//       /*
//        * Account-like/text fields should remain text.
//        */

//       const jobIdColumn =
//         GR_EXPECTED_COLUMNS.indexOf(
//           "Job ID"
//         ) + 1;

//       const roadNumberColumn =
//         GR_EXPECTED_COLUMNS.indexOf(
//           "Road Number"
//         ) + 1;

//       worksheet
//         .getColumn(jobIdColumn)
//         .numFmt = "@";

//       worksheet
//         .getColumn(roadNumberColumn)
//         .numFmt = "@";

//       /*
//        * Sample row
//        */

//      worksheet.addRow({
//         "Sr. No.": 1,
//         "Administrative Approved Year": "2026-2027",
//         District: "पुणे उत्तर",

//         Taluka: "हवेली",
//         "Work Name":
//           "ग्रामीण भागाचा सर्वांगीण विकास करण्यासाठी ग्रामपंचायत, जिल्हा परिषद आणि विविध सरकारी योजनांमार्फत",
//         "Work Amount": 10000,
//         "Class Of Work": "A",

//         "Job ID": "123456789",

//         "GR Date": "29-09-2026",

//         "GR Number": "GR-2026-001",

//         "Head Code": getAllowedHeadCode(),

//         "Constituency Name": "Pune",

//         "Multiple Gram Panchayat?": "No",

//         "Type of Work":
//           "रस्ते 'वाहतुकी योग्य' स्थितीत राखण्याची कामे (सर्वसाधारण दुरुस्ती)",

//         "Road Category": "Other District Road",

//         "Road Number": "12",

//         "Proposed Length (KM)": 2.5,

//         "Gram Panchayat": "Loni Kalbhor",

//         Remark: "Sample Remark",

//         "Proposal File Number": "PFN/2026/001",

//         "Proposal Date": "29-09-2026",
//       });

//       /*
//        * Sample second row
//        */

//       worksheet.addRow({
//         "Sr. No.": 2,
//         "Administrative Approved Year": "2026-2027",
//         District: "पुणे दक्षिण",

//         Taluka: "हवेली",
//         "Work Name":
//           "पंचायत समिती स्तरावर गट विकास",
//         "Work Amount": 500,

//         "Class Of Work": "B",

//         "Job ID": "123456789",

//         "GR Date": "29-09-2026",

//         "GR Number": "GR-2026-001",

//         "Head Code": getAllowedHeadCode(),

//         "Constituency Name": "Pune",

//         "Multiple Gram Panchayat?": "No",

//         "Type of Work":
//           "रस्ते 'वाहतुकी योग्य",

//         "Road Category": "Other District Road",

//         "Road Number": "102",

//         "Proposed Length (KM)": 8.5,

//         "Gram Panchayat": "Loni Kalbhor",

//         Remark: "Sample Remark",

//         "Proposal File Number": "PFN/2026/001",

//         "Proposal Date": "29-09-2026",
//       });


//       /*
//        * Date columns as text
//        */

//       const dateColumns = [
//         "GR Date",
//         "Proposal Date",
//       ];

//       dateColumns.forEach(
//         (column) => {
//           const columnNumber =
//             GR_EXPECTED_COLUMNS.indexOf(
//               column
//             ) + 1;

//           worksheet
//             .getColumn(columnNumber)
//             .numFmt = "@";
//         }
//       );

//       /*
//        * Money formatting
//        */

//       const amountColumn =
//         GR_EXPECTED_COLUMNS.indexOf(
//           "Work Amount"
//         ) + 1;

//       worksheet
//         .getColumn(amountColumn)
//         .numFmt = "#,##0.00";

//       /*
//        * Highlight ONLY mandatory columns
//        */

//       const mandatoryColumns =
//         GR_MANDATORY_COLUMNS;

//       mandatoryColumns.forEach(
//         (column) => {
//           const columnIndex =
//             GR_EXPECTED_COLUMNS.indexOf(
//               column
//             ) + 1;

//           worksheet
//             .getRow(1)
//             .getCell(columnIndex)
//             .fill = {
//               type: "pattern",
//               pattern: "solid",
//               fgColor: {
//                 argb: "FFFFFF",
//               },
//             };

//           worksheet
//             .getRow(1)
//             .getCell(columnIndex)
//             .font = {
//               bold: true,
//               color: {
//                 argb: "000000",
//               },
//             };
//         }
//       );

//       /*
//        * Freeze header
//        */

//       worksheet.views = [
//         {
//           state: "frozen",
//           ySplit: 1,
//         },
//       ];

//       /*
//        * Auto filter
//        */

//       worksheet.autoFilter = {
//         from: "A1",
//         to: `${String.fromCharCode(
//           64 + GR_EXPECTED_COLUMNS.length
//         )}1`,
//       };

//       const buffer =
//         await workbook.xlsx.writeBuffer();

//       saveAs(
//         new Blob([buffer]),
//         "GR_Proposal_Sample.xlsx"
//       );
//     } catch (error) {
//       console.error(
//         "Sample Excel generation error:",
//         error
//       );

//       alert(
//         "Unable to generate sample Excel."
//       );
//     }
//   };

//   /*
//    * ---------------------------------------------------------
//    * EXCEL UPLOAD
//    * ---------------------------------------------------------
//    */

//   const handleFileUpload = (event) => {
//     const file =
//       event.target.files?.[0];

//     if (!file) return;

//     setUploadError("");

//     /*
//      * Validate extension
//      */

//     const extension =
//       file.name
//         .split(".")
//         .pop()
//         ?.toLowerCase();

//     if (
//       extension !== "xlsx" &&
//       extension !== "xls"
//     ) {
//       alert(
//         "Please upload only .xls or .xlsx Excel file."
//       );

//       event.target.value = "";
//       return;
//     }

//     setSelectedFile(file);

//     const reader =
//       new FileReader();

//     reader.onload = (evt) => {
//       try {
//         const workbook = XLSX.read(
//           evt.target.result,
//           {
//             type: "binary",
//             cellDates: true,
//           }
//         );

//         if (
//           !workbook.SheetNames ||
//           workbook.SheetNames.length === 0
//         ) {
//           alert(
//             "Excel file contains no sheets."
//           );
//           return;
//         }

//         const sheet =
//           workbook.Sheets[
//             workbook.SheetNames[0]
//           ];

//         /*
//          * Read as array of arrays.
//          */

//         const rawRows =
//           XLSX.utils.sheet_to_json(
//             sheet,
//             {
//               header: 1,
//               defval: "",
//               raw: true,
//             }
//           );

//         /*
//          * -----------------------------------------------------
//          * FIND ACTUAL HEADER ROW
//          *
//          * IMPORTANT:
//          * Sr. No. is NOT mandatory anymore.
//          *
//          * Header row is detected using all 9
//          * mandatory columns.
//          * -----------------------------------------------------
//          */

//         const headerRowIndex =
//           rawRows.findIndex((row) => {
//             const rowHeaders =
//               row.map((cell) =>
//                 String(cell).trim()
//               );

//             return GR_MANDATORY_COLUMNS.every(
//               (column) =>
//                 rowHeaders.includes(column)
//             );
//           });

//         if (
//           headerRowIndex === -1
//         ) {
//           alert(
//             "Could not find all mandatory columns:\n\n" +
//               GR_MANDATORY_COLUMNS.join(
//                 "\n"
//               )
//           );

//           return;
//         }

//         /*
//          * Get headers.
//          */

//         const headers =
//           rawRows[
//             headerRowIndex
//           ].map((header) =>
//             String(header).trim()
//           );

//         /*
//          * Check duplicate columns.
//          */

//         const duplicateHeaders =
//           headers.filter(
//             (header, index) =>
//               header &&
//               headers.indexOf(
//                 header
//               ) !== index
//           );

//         if (
//           duplicateHeaders.length >
//           0
//         ) {
//           alert(
//             "Duplicate columns found:\n\n" +
//               [
//                 ...new Set(
//                   duplicateHeaders
//                 ),
//               ].join("\n")
//           );

//           return;
//         }

//         /*
//          * -----------------------------------------------------
//          * REQUIRED COLUMNS
//          *
//          * ONLY 9 MANDATORY COLUMNS
//          * -----------------------------------------------------
//          */

//         const missingColumns =
//           GR_MANDATORY_COLUMNS.filter(
//             (column) =>
//               !headers.includes(column)
//           );

//         if (
//           missingColumns.length > 0
//         ) {
//           alert(
//             "Missing Mandatory Columns:\n\n" +
//               missingColumns.join(
//                 "\n"
//               )
//           );

//           return;
//         }

//         /*
//          * -----------------------------------------------------
//          * CONVERT ROWS
//          *
//          * Sr. No. is NOT required.
//          *
//          * A row is considered a data row when
//          * at least one mandatory field has data.
//          * -----------------------------------------------------
//          */

//         const convertedRows =
//           rawRows
//             .slice(
//               headerRowIndex + 1
//             )
//             .filter((row) => {
//               return GR_MANDATORY_COLUMNS.some(
//                 (column) => {
//                   const columnIndex =
//                     headers.indexOf(
//                       column
//                     );

//                   if (
//                     columnIndex === -1
//                   ) {
//                     return false;
//                   }

//                   const value =
//                     row[
//                       columnIndex
//                     ];

//                   return (
//                     value !== "" &&
//                     value !== null &&
//                     value !==
//                       undefined
//                   );
//                 }
//               );
//             })
//             .map((row) => {
//               const excelRow = {};

//               headers.forEach(
//                 (
//                   header,
//                   index
//                 ) => {
//                   let value =
//                     row[index] ??
//                     "";

//                   if (
//                     header ===
//                       "GR Date" ||
//                     header ===
//                       "Proposal Date"
//                   ) {
//                     value =
//                       formatExcelDate(
//                         value
//                       );
//                   }

//                   if (
//                     header ===
//                     "Gram Panchayat"
//                   ) {
//                     value =
//                       normalizeGramPanchayat(
//                         value
//                       );
//                   }

//                   if (
//                     header ===
//                     "Multiple Gram Panchayat?"
//                   ) {
//                     value =
//                       normalizeMultipleGP(
//                         value
//                       );
//                   }

//                   if (
//                     header ===
//                     "Job ID"
//                   ) {
//                     value =
//                       String(
//                         value
//                       ).trim();

//                     /*
//                      * Avoid scientific notation
//                      */

//                     if (
//                       value.includes(
//                         "E+"
//                       )
//                     ) {
//                       value =
//                         Number(
//                           value
//                         ).toLocaleString(
//                           "fullwide",
//                           {
//                             useGrouping:
//                               false,
//                           }
//                         );
//                     }
//                   }

//                   excelRow[
//                     header
//                   ] = value;
//                 }
//               );

//               return excelRow;
//             });

//         if (
//           convertedRows.length ===
//           0
//         ) {
//           alert(
//             "No valid GR Proposal rows found in the Excel."
//           );

//           return;
//         }

//         /*
//          * -----------------------------------------------------
//          * VALIDATE ROWS
//          *
//          * ONLY 9 FIELDS ARE REQUIRED
//          * -----------------------------------------------------
//          */

//         const errors = [];

//         convertedRows.forEach(
//           (row, index) => {
//             const excelRowNumber =
//               headerRowIndex +
//               index +
//               2;

//             /*
//              * Administrative Approved Year
//              */
//                     if (
//     !String(
//       row["GR Number"] || ""
//     ).trim()
//   ) {
//     errors.push(
//       `Excel Row ${excelRowNumber}: GR Number is required.`
//     );
//   }

//             if (
//               !String(
//                 row[
//                   "Administrative Approved Year"
//                 ] || ""
//               ).trim()
//             ) {
//               errors.push(
//                 `Excel Row ${excelRowNumber}: Administrative Approved Year is required.`
//               );
//             }

//             /*
//              * Head Code
//              */

//             if (
//               !String(
//                 row[
//                   "Head Code"
//                 ] || ""
//               ).trim()
//             ) {
//               errors.push(
//                 `Excel Row ${excelRowNumber}: Head Code is required.`
//               );
//             }

//             /*
//              * Role-specific Head Code
//              */

//             if (
//               RoleID &&
//               String(
//                 row[
//                   "Head Code"
//                 ] || ""
//               ).trim() !==
//                 getAllowedHeadCode()
//             ) {
//               errors.push(
//                 `Excel Row ${excelRowNumber}: Head Code does not match the user's allowed Head Code.`
//               );
//             }

//             /*
//              * District
//              */

//             if (
//               !String(
//                 row[
//                   "District"
//                 ] || ""
//               ).trim()
//             ) {
//               errors.push(
//                 `Excel Row ${excelRowNumber}: District is required.`
//               );
//             }

//             /*
//              * Taluka
//              */

//             if (
//               !String(
//                 row[
//                   "Taluka"
//                 ] || ""
//               ).trim()
//             ) {
//               errors.push(
//                 `Excel Row ${excelRowNumber}: Taluka is required.`
//               );
//             }

//             /*
//              * Class Of Work
//              */

//             if (
//               !String(
//                 row[
//                   "Class Of Work"
//                 ] || ""
//               ).trim()
//             ) {
//               errors.push(
//                 `Excel Row ${excelRowNumber}: Class Of Work is required.`
//               );
//             }

//             /*
//              * Work Name
//              */

//             if (
//               !String(
//                 row[
//                   "Work Name"
//                 ] || ""
//               ).trim()
//             ) {
//               errors.push(
//                 `Excel Row ${excelRowNumber}: Work Name is required.`
//               );
//             }

//             /*
//              * Job ID
//              */

//             if (
//               !String(
//                 row[
//                   "Job ID"
//                 ] || ""
//               ).trim()
//             ) {
//               errors.push(
//                 `Excel Row ${excelRowNumber}: Job ID is required.`
//               );
//             }

//             /*
//              * GR Date
//              */

//             if (
//               !row["GR Date"] ||
//               !isValidDate(
//                 row["GR Date"]
//               )
//             ) {
//               errors.push(
//                 `Excel Row ${excelRowNumber}: Invalid GR Date.`
//               );
//             }

//             /*
//              * Work Amount
//              */

//             const workAmount =
//               row[
//                 "Work Amount"
//               ];

//             if (
//               !isValidAmount(
//                 workAmount
//               )
//             ) {
//               errors.push(
//                 `Excel Row ${excelRowNumber}: Work Amount must contain numbers only.`
//               );
//             } else if (
//               Number(
//                 workAmount
//               ) <= 0
//             ) {
//               errors.push(
//                 `Excel Row ${excelRowNumber}: Work Amount must be greater than 0.`
//               );
//             }

//             /*
//              * Future GR Date
//              */

//             const today =
//               new Date();

//             today.setHours(
//               23,
//               59,
//               59,
//               999
//             );

//             if (
//               row["GR Date"] &&
//               new Date(
//                 row["GR Date"]
//               ) > today
//             ) {
//               errors.push(
//                 `Excel Row ${excelRowNumber}: GR Date cannot be a future date.`
//               );
//             }

//             /*
//              * -------------------------------------------------
//              * OPTIONAL FIELDS ARE NOT VALIDATED
//              *
//              * GR Number
//              * Constituency Name
//              * Multiple Gram Panchayat?
//              * Type of Work
//              * Road Category
//              * Road Number
//              * Proposed Length (KM)
//              * Gram Panchayat
//              * Remark
//              * Proposal File Number
//              * Proposal Date
//              * -------------------------------------------------
//              */
//           }
//         );

//         /*
//          * -----------------------------------------------------
//          * DUPLICATE WORK VALIDATION
//          * -----------------------------------------------------
//          */

//         const duplicateRows = [];

//         for (
//           let i = 0;
//           i < convertedRows.length;
//           i++
//         ) {
//           for (
//             let j = i + 1;
//             j <
//             convertedRows.length;
//             j++
//           ) {
//             const first =
//               convertedRows[i];

//             const second =
//               convertedRows[j];

//             const same =
//               String(
//                 first[
//                   "Work Name"
//                 ] || ""
//               )
//                 .trim()
//                 .toLowerCase() ===
//                 String(
//                   second[
//                     "Work Name"
//                   ] || ""
//                 )
//                   .trim()
//                   .toLowerCase() &&
//               String(
//                 first[
//                   "Administrative Approved Year"
//                 ] || ""
//               ).trim() ===
//                 String(
//                   second[
//                     "Administrative Approved Year"
//                   ] || ""
//                 ).trim() &&
//               String(
//                 first[
//                   "Head Code"
//                 ] || ""
//               ).trim() ===
//                 String(
//                   second[
//                     "Head Code"
//                   ] || ""
//                 ).trim() &&
//               String(
//                 first[
//                   "District"
//                 ] || ""
//               ).trim() ===
//                 String(
//                   second[
//                     "District"
//                   ] || ""
//                 ).trim() &&
//               String(
//                 first[
//                   "Taluka"
//                 ] || ""
//               ).trim() ===
//                 String(
//                   second[
//                     "Taluka"
//                   ] || ""
//                 ).trim() &&
//               String(
//                 first[
//                   "Job ID"
//                 ] || ""
//               ).trim() ===
//                 String(
//                   second[
//                     "Job ID"
//                   ] || ""
//                 ).trim();

//             if (same) {
//               duplicateRows.push(
//                 `Rows ${
//                   i + 1
//                 } and ${
//                   j + 1
//                 } appear to be duplicate works.`
//               );
//             }
//           }
//         }

//         if (
//           duplicateRows.length >
//           0
//         ) {
//           errors.push(
//             ...duplicateRows
//           );
//         }

//         /*
//          * -----------------------------------------------------
//          * SHOW ERRORS
//          * -----------------------------------------------------
//          */

//         if (
//           errors.length > 0
//         ) {
//           const errorText =
//             errors
//               .slice(0, 50)
//               .join("\n");

//           setUploadError(
//             errorText
//           );

//           alert(
//             `Excel validation failed.\n\n${errorText}${
//               errors.length > 50
//                 ? "\n\n...and more errors."
//                 : ""
//             }`
//           );

//           return;
//         }

//         /*
//          * -----------------------------------------------------
//          * CONVERT EXCEL ROWS TO EXACT BACKEND STRUCTURE
//          * -----------------------------------------------------
//          */

//         const backendRows =
//           convertedRows.map(
//             (row) => ({
//               GRNumber:
//                 String(
//                   row[
//                     "GR Number"
//                   ] || ""
//                 ).trim(),

//               GRDate:
//                 formatExcelDate(
//                   row["GR Date"]
//                 ),

//               ProposalYear:
//                 String(
//                   row[
//                     "Administrative Approved Year"
//                   ] || ""
//                 ).trim(),

//               HeadCode:
//                 String(
//                   row[
//                     "Head Code"
//                   ] || ""
//                 ).trim(),

//               District:
//                 String(
//                   row[
//                     "District"
//                   ] || ""
//                 ).trim(),

//               Taluka:
//                 String(
//                   row[
//                     "Taluka"
//                   ] || ""
//                 ).trim(),

//               ConstituencyName:
//                 String(
//                   row[
//                     "Constituency Name"
//                   ] || ""
//                 ).trim(),

//               isMultipleGp:
//                 normalizeMultipleGP(
//                   row[
//                     "Multiple Gram Panchayat?"
//                   ]
//                 ),

//               classOfWork:
//                 String(
//                   row[
//                     "Class Of Work"
//                   ] || ""
//                 ).trim(),

//               typeOfWork:
//                 String(
//                   row[
//                     "Type of Work"
//                   ] || ""
//                 ).trim(),

//               proposalworkname:
//                 String(
//                   row[
//                     "Work Name"
//                   ] || ""
//                 ).trim(),

//               JobId:
//                 String(
//                   row[
//                     "Job ID"
//                   ] || ""
//                 ).trim(),

//               roadCategory:
//                 String(
//                   row[
//                     "Road Category"
//                   ] || ""
//                 ).trim(),

//               roadNumber:
//                 String(
//                   row[
//                     "Road Number"
//                   ] || ""
//                 ).trim(),

//               proposedLength:
//                 String(
//                   row[
//                     "Proposed Length (KM)"
//                   ] ?? ""
//                 ).trim(),

//               gramPanchayat:
//                 normalizeGramPanchayat(
//                   row[
//                     "Gram Panchayat"
//                   ]
//                 ),

//               proposalworkamount:
//                 String(
//                   row[
//                     "Work Amount"
//                   ] ?? ""
//                 ).trim(),

//               remark:
//                 String(
//                   row["Remark"] ||
//                     ""
//                 ).trim(),

//               ProposalFileNumber:
//                 String(
//                   row[
//                     "Proposal File Number"
//                   ] || ""
//                 ).trim(),

//               proposalDate:
//                 formatExcelDate(
//                   row[
//                     "Proposal Date"
//                   ]
//                 ),

//               GRamount: "",
//             })
//           );

//         /*
//          * Calculate total.
//          */

//         const total =
//           backendRows.reduce(
//             (sum, row) =>
//               sum +
//               Number(
//                 row.proposalworkamount ||
//                   0
//               ),
//             0
//           );

//         /*
//          * Set preview.
//          */

//         setTableData(
//           backendRows
//         );

//         setCurrentPage(1);

//         setShowAll(false);

//         setUploadError("");

//         console.log(
//           "GR Excel Backend Rows:",
//           backendRows
//         );

//         alert(
//           `${backendRows.length} GR Proposal row(s) loaded successfully.\n\nTotal Proposal Amount: ₹${total.toLocaleString(
//             "en-IN",
//             {
//               minimumFractionDigits:
//                 2,
//               maximumFractionDigits:
//                 2,
//             }
//           )}`
//         );
//       } catch (error) {
//         console.error(
//           "Excel processing error:",
//           error
//         );

//         setUploadError(
//           error?.message ||
//             "Unable to process Excel file."
//         );

//         alert(
//           "Unable to process the Excel file. Please check the file format."
//         );
//       }
//     };

//     reader.onerror = () => {
//       alert(
//         "Unable to read the selected Excel file."
//       );
//     };

//     reader.readAsBinaryString(file);
//   };

//   /*
//    * ---------------------------------------------------------
//    * DELETE ROW
//    * ---------------------------------------------------------
//    */

//   const handleDelete = (index) => {
//     const actualIndex =
//       indexOfFirst + index;

//     const updated =
//       tableData.filter(
//         (_, i) =>
//           i !== actualIndex
//       );

//     setTableData(updated);

//     const newTotalPages =
//       Math.ceil(
//         updated.length /
//           BILLS_PER_PAGE
//       );

//     if (
//       currentPage >
//         newTotalPages &&
//       newTotalPages > 0
//     ) {
//       setCurrentPage(
//         newTotalPages
//       );
//     }
//   };

//   /*
//    * ---------------------------------------------------------
//    * CLEAR EXCEL
//    * ---------------------------------------------------------
//    */

//   const handleClear = () => {
//     if (
//       tableData.length > 0
//     ) {
//       const confirmed =
//         window.confirm(
//           "Are you sure you want to clear all uploaded GR Proposal rows?"
//         );

//       if (!confirmed) {
//         return;
//       }
//     }

//     setTableData([]);

//     setSelectedFile(null);

//     setUploadError("");

//     setCurrentPage(1);

//     setShowAll(false);

//     const fileInput =
//       document.getElementById(
//         "gr-proposal-excel"
//       );

//     if (fileInput) {
//       fileInput.value = "";
//     }
//   };

//   /*
//    * ---------------------------------------------------------
//    * TOTAL AMOUNT
//    * ---------------------------------------------------------
//    */

//   const totalAmount =
//     tableData.reduce(
//       (sum, row) =>
//         sum +
//         Number(
//           row.proposalworkamount ||
//             0
//         ),
//       0
//     );

//   /*
//    * ---------------------------------------------------------
//    * SUBMIT
//    * ---------------------------------------------------------
//    */

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (
//       tableData.length === 0
//     ) {
//       alert(
//         "No GR Proposal data found. Please upload Excel first."
//       );

//       return;
//     }

//     /*
//      * -------------------------------------------------------
//      * FINAL VALIDATION
//      *
//      * ONLY 9 FIELDS ARE REQUIRED
//      * -------------------------------------------------------
//      */

//     const invalidRows =
//       tableData.filter(
//         (row) =>
//           !row.GRNumber ||
//           !row.ProposalYear ||
//           !row.GRDate ||
//           !row.HeadCode ||
//           !row.District ||
//           !row.Taluka ||
//           !row.classOfWork ||
//           !row.proposalworkname ||
//           !row.JobId ||
//           !row.proposalworkamount
//       );

//     if (
//       invalidRows.length > 0
//     ) {
//       alert(
//         `${invalidRows.length} row(s) contain missing mandatory data. Please upload a corrected Excel.`
//       );

//       return;
//     }

//     /*
//      * Validate amount again.
//      */

//     const invalidAmount =
//       tableData.filter(
//         (row) =>
//           !isValidAmount(
//             row.proposalworkamount
//           ) ||
//           Number(
//             row.proposalworkamount
//           ) <= 0
//       );

//     if (
//       invalidAmount.length > 0
//     ) {
//       alert(
//         "One or more rows have an invalid Work Amount."
//       );

//       return;
//     }

//     setLoading(true);

//     try {
//       const formData =
//         new FormData();

//       /*
//        * Calculate GR amount for every row
//        * based on its GR Number.
//        */

//       const updatedTable =
//         tableData.map((row) => {
//           const totalGRAmount =
//             tableData
//               .filter(
//                 (item) =>
//                   item.GRNumber ===
//                   row.GRNumber
//               )
//               .reduce(
//                 (sum, item) =>
//                   sum +
//                   Number(
//                     item.proposalworkamount ||
//                       0
//                   ),
//                 0
//               );

//           return {
//             ...row,
//             GRamount:
//               totalGRAmount,
//           };
//         });

//       /*
//        * Existing backend payload.
//        */

//       formData.append(
//         "TotalProposalAmount",
//         String(totalAmount)
//       );

//       formData.append(
//         "WorkTableData",
//         JSON.stringify(
//           updatedTable
//         )
//       );

//       console.log(
//         "Submitting GR Proposal Excel data:",
//         updatedTable
//       );

//       const result =
//         await GRProposalCreationFunction(
//           formData
//         );

//       console.log(
//         "GR Proposal submit response:",
//         result
//       );

//       const status =
//         result?.status;

//       const message =
//         result?.message;

//       if (status) {
//         alert(
//           message ||
//             "GR Proposal created successfully."
//         );

//         setTableData([]);

//         setSelectedFile(null);

//         setCurrentPage(1);

//         setShowAll(false);

//         const fileInput =
//           document.getElementById(
//             "gr-proposal-excel"
//           );

//         if (fileInput) {
//           fileInput.value = "";
//         }

//         window.location.reload();
//       } else {
//         alert(
//           message ||
//             (typeof result ===
//             "string"
//               ? result
//               : "GR Proposal submission failed.")
//         );
//       }
//     } catch (error) {
//       console.error(
//         "GR Proposal submission error:",
//         error
//       );

//       alert(
//         "Error while submitting GR Proposal."
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   /*
//    * ---------------------------------------------------------
//    * FORMAT PREVIEW VALUE
//    * ---------------------------------------------------------
//    */

//   const getPreviewValue = (
//     row,
//     column
//   ) => {
//     switch (column) {
//       case "GR Number":
//         return row.GRNumber;

//       case "Administrative Approved Year":
//         return row.ProposalYear;

//       case "Head Code":
//         return row.HeadCode;

//       case "District":
//         return row.District;

//       case "Taluka":
//         return row.Taluka;

//       case "Constituency Name":
//         return row.ConstituencyName;

//       case "Multiple Gram Panchayat?":
//         return row.isMultipleGp;

//       case "Class Of Work":
//         return row.classOfWork;

//       case "Type of Work":
//         return row.typeOfWork;

//       case "Work Name":
//         return row.proposalworkname;

//       case "Job ID":
//         return row.JobId;

//       case "Road Category":
//         return row.roadCategory;

//       case "Road Number":
//         return row.roadNumber;

//       case "Proposed Length (KM)":
//         return row.proposedLength;

//       case "Gram Panchayat":
//         return Array.isArray(
//           row.gramPanchayat
//         )
//           ? row.gramPanchayat.join(
//               ", "
//             )
//           : row.gramPanchayat;

//       case "Work Amount":
//         return `₹${Number(
//           row.proposalworkamount ||
//             0
//         ).toLocaleString(
//           "en-IN",
//           {
//             minimumFractionDigits:
//               2,
//             maximumFractionDigits:
//               2,
//           }
//         )}`;

//       case "Remark":
//         return row.remark;

//       case "Proposal File Number":
//         return row.ProposalFileNumber;

//       case "Proposal Date":
//         return row.proposalDate;

//       case "GR Date":
//         return row.GRDate;

//       default:
//         return "";
//     }
//   };

//   /*
//    * ---------------------------------------------------------
//    * UI
//    *
//    * KEPT SAME AS YOUR ORIGINAL UI
//    * ---------------------------------------------------------
//    */

//   const GR_PREVIEW_COLUMNS =
//     GR_EXPECTED_COLUMNS.filter(
//       (column) =>
//         column !== "Sr. No."
//     );

//   return (
//     <div
//       className="col-12"
//       style={{
//         height: "91vh",
//         overflowY: "auto",
//         backgroundColor:
//           "#FFFFFF",
//         paddingBottom: "40px",
//       }}
//     >
//       <div
//         className="col-12"
//         style={{
//           padding:
//             "2px 0px 5px 0px",
//         }}
//       >
//         <div
//           className="col-12 m-auto my-5 budgetContainer19"
//           style={{
//             paddingBottom: "30px",
//           }}
//         >
//           <div className="m-auto budgetElement">

//             {/* HEADER */}

//             <div
//               style={{
//                 display: "flex",
//                 justifyContent:
//                   "space-between",
//                 alignItems:
//                   "center",
//                 padding:
//                   "15px 20px",
//                 borderBottom:
//                   "1px solid #e4e8ec",
//               }}
//             >
//               <div>
//                 <h5
//                   style={{
//                     margin: 0,
//                     display: "flex",
//                     alignItems:
//                       "center",
//                     gap: "8px",
//                   }}
//                 >
//                   <img
//                     src={
//                       ProposalCreation32
//                     }
//                     alt="GR Proposal"
//                   />

//                   {t(
//                     "Create GR Proposal"
//                   )}
//                 </h5>
//               </div>
//             </div>

//             {/* LOADER */}

//             {loading && (
//               <div
//                 style={{
//                   position:
//                     "fixed",
//                   inset: 0,
//                   background:
//                     "rgba(255,255,255,0.7)",
//                   backdropFilter:
//                     "blur(4px)",
//                   zIndex: 9999,
//                   display:
//                     "flex",
//                   justifyContent:
//                     "center",
//                   alignItems:
//                     "center",
//                 }}
//               >
//                 <div
//                   style={{
//                     border:
//                       "6px solid #f3f3f3",
//                     borderTop:
//                       "6px solid #007bff",
//                     borderRadius:
//                       "50%",
//                     width: "60px",
//                     height: "60px",
//                     animation:
//                       "spin 1s linear infinite",
//                   }}
//                 />
//               </div>
//             )}

//             {/* SAMPLE DOWNLOAD */}

//             <div
//               style={{
//                 margin:
//                   "0 20px 15px",
//                 display:
//                   "flex",
//                 justifyContent:
//                   "space-between",
//                 alignItems:
//                   "center",
//                 flexWrap:
//                   "wrap",
//                 gap: "10px",
//               }}
//             >
//               <button
//                 type="button"
//                 onClick={
//                   downloadSampleExcel
//                 }
//                 style={{
//                   border: "none",
//                   background:
//                     "transparent",
//                   color:
//                     "#007bff",
//                   cursor:
//                     "pointer",
//                   fontWeight:
//                     "600",
//                   textDecoration:
//                     "underline",
//                   fontSize:
//                     "14px",
//                 }}
//               >
//                 Download GR Proposal Sample Excel
//               </button>
//             </div>

//             {/* FILE UPLOAD */}

//             <div
//               style={{
//                 margin:
//                   "0 20px 20px",
//                 padding:
//                   "20px",
//                 background:
//                   "#ffffff",
//                 border:
//                   "1px solid #dfe5eb",
//                 borderRadius:
//                   "8px",
//                 boxShadow:
//                   "0 2px 6px rgba(0,0,0,0.05)",
//               }}
//             >
//               <label
//                 style={{
//                   display:
//                     "block",
//                   fontWeight:
//                     "600",
//                   marginBottom:
//                     "8px",
//                 }}
//               >
//                 Upload GR Proposal Excel
//                 <span
//                   style={{
//                     color:
//                       "red",
//                   }}
//                 >
//                   {" "}
//                   *
//                 </span>
//               </label>

//               <input
//                 id="gr-proposal-excel"
//                 type="file"
//                 accept=".xls,.xlsx"
//                 className="form-control"
//                 onChange={
//                   handleFileUpload
//                 }
//               />

//               {selectedFile && (
//                 <div
//                   style={{
//                     marginTop:
//                       "8px",
//                     fontSize:
//                       "13px",
//                     color:
//                       "#555",
//                   }}
//                 >
//                   Selected File:{" "}
//                   <strong>
//                     {
//                       selectedFile.name
//                     }
//                   </strong>
//                 </div>
//               )}
//             </div>

//             {/* ERROR */}

//             {uploadError && (
//               <div
//                 style={{
//                   margin:
//                     "0 20px 20px",
//                   padding:
//                     "15px",
//                   background:
//                     "#fff0f0",
//                   border:
//                     "1px solid #f1b8b8",
//                   borderRadius:
//                     "6px",
//                   color:
//                     "#b60101",
//                   whiteSpace:
//                     "pre-wrap",
//                   fontSize:
//                     "13px",
//                   maxHeight:
//                     "250px",
//                   overflowY:
//                     "auto",
//                 }}
//               >
//                 <strong>
//                   Excel Validation Error
//                 </strong>

//                 <div
//                   style={{
//                     marginTop:
//                       "8px",
//                   }}
//                 >
//                   {uploadError}
//                 </div>
//               </div>
//             )}

//             {/* PREVIEW */}

//             {tableData.length >
//               0 && (
//               <div
//                 style={{
//                   margin:
//                     "0 20px",
//                 }}
//               >
//                 <div
//                   style={{
//                     display:
//                       "flex",
//                     justifyContent:
//                       "space-between",
//                     alignItems:
//                       "center",
//                     marginBottom:
//                       "10px",
//                     flexWrap:
//                       "wrap",
//                     gap: "10px",
//                   }}
//                 >
//                   <h6
//                     style={{
//                       margin: 0,
//                       fontWeight:
//                         "700",
//                     }}
//                   >
//                     Excel Preview
//                   </h6>

//                   <button
//                     type="button"
//                     onClick={
//                       handleClear
//                     }
//                     style={{
//                       border:
//                         "none",
//                       background:
//                         "#dc3545",
//                       color:
//                         "#fff",
//                       borderRadius:
//                         "4px",
//                       padding:
//                         "7px 14px",
//                       cursor:
//                         "pointer",
//                       fontWeight:
//                         "600",
//                     }}
//                   >
//                     Clear Excel
//                   </button>
//                 </div>

//                 <div
//                   style={{
//                     background:
//                       "white",
//                     boxShadow:
//                       "0px 0px 5px 1px #E4E8EC",
//                     width:
//                       "100%",
//                     overflow:
//                       "hidden",
//                     borderRadius:
//                       "6px",
//                     border:
//                       "1px solid #ddd",
//                   }}
//                 >
//                   <div
//                     style={{
//                       maxHeight:
//                         "500px",
//                       overflowY:
//                         "auto",
//                       overflowX:
//                         "auto",
//                     }}
//                   >
//                     <table
//                       style={{
//                         width:
//                           "100%",
//                         borderCollapse:
//                           "collapse",
//                         fontSize:
//                           "13px",
//                         minWidth:
//                           "2800px",
//                       }}
//                     >
//                       <thead
//                         style={{
//                           position:
//                             "sticky",
//                           top: 0,
//                           zIndex: 2,
//                         }}
//                       >
//                         <tr
//                           style={{
//                             background:
//                               "#2C78DB",
//                             color:
//                               "white",
//                           }}
//                         >
//                           <th
//                             style={{
//                               padding:
//                                 "9px",
//                               border:
//                                 "1px solid #ddd",
//                               minWidth:
//                                 "55px",
//                             }}
//                           >
//                             Sr.No
//                           </th>

//                           {GR_PREVIEW_COLUMNS.map(
//                             (
//                               column
//                             ) => (
//                               <th
//                                 key={
//                                   column
//                                 }
//                                 style={{
//                                   padding:
//                                     "9px",
//                                   border:
//                                     "1px solid #ddd",
//                                   minWidth:
//                                     column ===
//                                     "Work Name"
//                                       ? "250px"
//                                       : "160px",
//                                   whiteSpace:
//                                     "nowrap",
//                                 }}
//                               >
//                                 {
//                                   column
//                                 }
//                               </th>
//                             )
//                           )}

//                           <th
//                             style={{
//                               padding:
//                                 "9px",
//                               border:
//                                 "1px solid #ddd",
//                               minWidth:
//                                 "90px",
//                             }}
//                           >
//                             Action
//                           </th>
//                         </tr>
//                       </thead>

//                       <tbody>
//                         {currentRows.map(
//                           (
//                             row,
//                             index
//                           ) => (
//                             <tr
//                               key={
//                                 index
//                               }
//                               style={{
//                                 backgroundColor:
//                                   index %
//                                     2 ===
//                                   0
//                                     ? "#E5F4FB"
//                                     : "#ffffff",
//                               }}
//                             >
//                               <td
//                                 style={{
//                                   padding:
//                                     "7px",
//                                   border:
//                                     "1px solid #ddd",
//                                   textAlign:
//                                     "center",
//                                   fontWeight:
//                                     "600",
//                                 }}
//                               >
//                                 {indexOfFirst +
//                                   index +
//                                   1}
//                               </td>

//                               {GR_PREVIEW_COLUMNS.map(
//                                 (
//                                   column
//                                 ) => (
//                                   <td
//                                     key={
//                                       column
//                                     }
//                                     style={{
//                                       padding:
//                                         "7px 10px",
//                                       border:
//                                         "1px solid #ddd",
//                                       whiteSpace:
//                                         column ===
//                                           "Work Name" ||
//                                         column ===
//                                           "Gram Panchayat" ||
//                                         column ===
//                                           "Remark"
//                                           ? "normal"
//                                           : "nowrap",
//                                       maxWidth:
//                                         column ===
//                                         "Work Name"
//                                           ? "300px"
//                                           : undefined,
//                                       wordBreak:
//                                         "break-word",
//                                     }}
//                                   >
//                                     {getPreviewValue(
//                                       row,
//                                       column
//                                     )}
//                                   </td>
//                                 )
//                               )}

//                               <td
//                                 style={{
//                                   padding:
//                                     "7px",
//                                   border:
//                                     "1px solid #ddd",
//                                   textAlign:
//                                     "center",
//                                 }}
//                               >
//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     handleDelete(
//                                       index
//                                     )
//                                   }
//                                   style={{
//                                     background:
//                                       "#dc3545",
//                                     color:
//                                       "#fff",
//                                     border:
//                                       "none",
//                                     borderRadius:
//                                       "4px",
//                                     padding:
//                                       "5px 10px",
//                                     cursor:
//                                       "pointer",
//                                   }}
//                                 >
//                                   Delete
//                                 </button>
//                               </td>
//                             </tr>
//                           )
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>

//                 {/* PAGINATION */}

//                 <div
//                   style={{
//                     marginTop:
//                       "15px",
//                     display:
//                       "flex",
//                     justifyContent:
//                       "space-between",
//                     alignItems:
//                       "center",
//                     flexWrap:
//                       "wrap",
//                     gap: "10px",
//                   }}
//                 >
//                   <div
//                     style={{
//                       fontSize:
//                         "13px",
//                       color:
//                         "#555",
//                     }}
//                   >
//                     Showing{" "}
//                     {indexOfFirst +
//                       1}{" "}
//                     to{" "}
//                     {Math.min(
//                       indexOfLast,
//                       tableData.length
//                     )}{" "}
//                     of{" "}
//                     {
//                       tableData.length
//                     }{" "}
//                     entries
//                   </div>

//                   <div
//                     style={{
//                       display:
//                         "flex",
//                       alignItems:
//                         "center",
//                       gap: "10px",
//                     }}
//                   >
//                     <GooglePagination
//                       currentPage={
//                         currentPage
//                       }
//                       totalPages={
//                         totalPages
//                       }
//                       onPageChange={
//                         setCurrentPage
//                       }
//                     />

//                     <button
//                       type="button"
//                       onClick={() => {
//                         setShowAll(
//                           !showAll
//                         );

//                         setCurrentPage(
//                           1
//                         );
//                       }}
//                       style={{
//                         border:
//                           "none",
//                         outline:
//                           "none",
//                         cursor:
//                           "pointer",
//                         padding:
//                           "8px 16px",
//                         borderRadius:
//                           "20px",
//                         fontSize:
//                           "13px",
//                         fontWeight:
//                           "600",
//                         color:
//                           "#fff",
//                         background:
//                           showAll
//                             ? "linear-gradient(135deg, #28a745, #20c997)"
//                             : "linear-gradient(135deg, #0067ab, #0098d5)",
//                         boxShadow:
//                           "0 2px 8px rgba(0,0,0,0.15)",
//                       }}
//                     >
//                       {showAll
//                         ? "✓ Showing All"
//                         : "View All"}
//                     </button>
//                   </div>
//                 </div>

//                 {/* SUBMIT */}

//                 <div
//                   style={{
//                     marginTop:
//                       "25px",
//                     marginBottom:
//                       "20px",
//                     display:
//                       "flex",
//                     justifyContent:
//                       "flex-end",
//                     gap: "10px",
//                   }}
//                 >
//                   <button
//                     type="button"
//                     onClick={
//                       handleClear
//                     }
//                     style={{
//                       display:
//                         "flex",
//                       alignItems:
//                         "center",
//                       justifyContent:
//                         "center",
//                       gap: "5px",
//                       background:
//                         "#f1594c",
//                       color:
//                         "#fff",
//                       width:
//                         "100px",
//                       height:
//                         "38px",
//                       fontSize:
//                         "14px",
//                       border:
//                         "none",
//                       borderRadius:
//                         "5px",
//                       cursor:
//                         "pointer",
//                     }}
//                   >
//                     Clear
//                   </button>

//                   <button
//                     type="button"
//                     onClick={
//                       handleSubmit
//                     }
//                     disabled={
//                       loading ||
//                       tableData.length ===
//                         0
//                     }
//                     style={{
//                       display:
//                         "flex",
//                       alignItems:
//                         "center",
//                       justifyContent:
//                         "center",
//                       gap: "5px",
//                       background:
//                         tableData.length >
//                         0
//                           ? "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)"
//                           : "#999",
//                       color:
//                         "white",
//                       width:
//                         "120px",
//                       height:
//                         "38px",
//                       fontSize:
//                         "16px",
//                       border:
//                         "none",
//                       borderRadius:
//                         "5px",
//                       cursor:
//                         tableData.length >
//                         0
//                           ? "pointer"
//                           : "not-allowed",
//                     }}
//                   >
//                     <img
//                       src={submit}
//                       alt="submit"
//                       style={{
//                         width:
//                           "15px",
//                       }}
//                     />

//                     Save
//                   </button>
//                 </div>
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <style>
//         {`
//           @keyframes spin {
//             0% {
//               transform: rotate(0deg);
//             }

//             100% {
//               transform: rotate(360deg);
//             }
//           }

//           .budgetElement {
//             width: 100%;
//           }

//           table th {
//             vertical-align: middle;
//           }

//           table td {
//             vertical-align: middle;
//           }

//           input[type="file"] {
//             cursor: pointer;
//           }
//         `}
//       </style>
//     </div>
//   );
// };

// export default UploadGRProposalCreation;
import React, { useContext, useEffect, useState } from "react";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Application from "../../../StateContext/Application.js";
import { ProposalCreation32 } from "../../../../../public/LoginImages/importimages.js";
import { submit } from "../../../../../public/LoginImages/importimages.js";
import GooglePagination from "../../../styles/GooglePagination";
import { useLanguage } from "../../../../../lang/langcontext/LanguageContext.js";

const GR_EXPECTED_COLUMNS = [
  "Sr. No.",
  "Administrative Approved Year",
  "District",
  "Taluka",
  "Work Name",
  "Class Of Work",
  "Work Amount",
  "Job ID",
  "GR Date",
  "GR Number",
  "Head Code",
  "Constituency Name",
  "Multiple Gram Panchayat?",
  "Type of Work",
  "Road Category",
  "Road Number",
  "Proposed Length (KM)",
  "Gram Panchayat",
  "Remark",
  "Proposal File Number",
  "Proposal Date",
];

/*
 * ONLY THESE 9 FIELDS ARE MANDATORY
 */
const GR_MANDATORY_COLUMNS = [
  "GR Number",
  "Administrative Approved Year",
  "District",
  "Taluka",
  "Work Name",
  "Class Of Work",
  "Work Amount",
  "Job ID",
  "GR Date",
];

const MONEY_COLUMNS = ["Work Amount"];

const formatExcelDate = (value) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  if (typeof value === "number") {
    const parsed = XLSX.SSF.parse_date_code(value);

    if (parsed) {
      const dd = String(parsed.d).padStart(2, "0");
      const mm = String(parsed.m).padStart(2, "0");
      const yyyy = parsed.y;

      return `${yyyy}-${mm}-${dd}`;
    }
  }

  if (value instanceof Date && !isNaN(value.getTime())) {
    const yyyy = value.getFullYear();
    const mm = String(value.getMonth() + 1).padStart(2, "0");
    const dd = String(value.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  }

  const str = String(value).trim();

  // DD-MM-YYYY
  if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(str)) {
    const [d, m, y] = str.split("-");

    return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
  }

  // DD/MM/YYYY
  if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(str)) {
    const [d, m, y] = str.split("/");

    return `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
  }

  // YYYY-MM-DD
  if (/^\d{4}-\d{2}-\d{2}$/.test(str)) {
    return str;
  }

  // Excel sometimes gives date strings with time
  const parsedDate = new Date(str);

  if (!isNaN(parsedDate.getTime())) {
    const yyyy = parsedDate.getFullYear();
    const mm = String(parsedDate.getMonth() + 1).padStart(2, "0");
    const dd = String(parsedDate.getDate()).padStart(2, "0");

    return `${yyyy}-${mm}-${dd}`;
  }

  return str;
};

const isValidDate = (value) => {
  if (!value) return false;

  const date = new Date(value);

  return !isNaN(date.getTime());
};

const isValidAmount = (value) => {
  if (value === null || value === undefined || String(value).trim() === "") {
    return false;
  }

  return /^\d+(\.\d{1,2})?$/.test(String(value).trim());
};

const normalizeGramPanchayat = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => String(item).trim()).filter(Boolean);
  }

  if (!value) {
    return [];
  }

  return String(value)
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
};

const normalizeMultipleGP = (value) => {
  const str = String(value ?? "")
    .trim()
    .toLowerCase();

  if (str === "yes" || str === "y" || str === "true") {
    return "Yes";
  }

  if (str === "no" || str === "n" || str === "false") {
    return "No";
  }

  return String(value ?? "").trim();
};

const UploadGRProposalCreation = () => {
  const operation = useContext(Application);

  const { GRProposalCreationFunction, Usermenu } = operation;

  const { t } = useLanguage();

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [RoleID, setRoleID] = useState(null);

  const [selectedFile, setSelectedFile] = useState(null);
const [uploadOrderFile, setUploadOrderFile] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [showAll, setShowAll] = useState(false);

  const [uploadError, setUploadError] = useState("");

  const BILLS_PER_PAGE = showAll ? tableData.length || 1 : 10;

  const totalPages = Math.ceil(tableData.length / BILLS_PER_PAGE);

  const indexOfLast = currentPage * BILLS_PER_PAGE;

  const indexOfFirst = indexOfLast - BILLS_PER_PAGE;

  const currentRows = tableData.slice(indexOfFirst, indexOfLast);

  /*
   * ---------------------------------------------------------
   * GET USER ROLE
   * ---------------------------------------------------------
   */

  const getmenu = async () => {
    try {
      const result = await Usermenu();

      if (!result || typeof result !== "object") {
        console.error("Invalid Usermenu response:", result);
        return;
      }

      const roleID = result?.Data?.RoleID;

      setRoleID(roleID);

      console.log("GR Excel Upload RoleID:", roleID);
    } catch (error) {
      console.error("Error fetching user role:", error);
    }
  };

  useEffect(() => {
    getmenu();
  }, []);

  /*
   * ---------------------------------------------------------
   * ALLOWED HEAD CODE
   * ---------------------------------------------------------
   */

  const getAllowedHeadCode = () => {
    if (RoleID === 25 || RoleID === 24) {
      return "3054-2419(Roads and bridge repair maintenance program)";
    }

    return "2515-1238(MLA Representative)";
  };

  /*
   * ---------------------------------------------------------
   * DOWNLOAD SAMPLE EXCEL
   * ---------------------------------------------------------
   */

  const downloadSampleExcel = async () => {
    try {
      const workbook = new ExcelJS.Workbook();

      const worksheet = workbook.addWorksheet("GR Proposal");

      worksheet.columns = GR_EXPECTED_COLUMNS.map((column) => ({
        header: column,
        key: column,
        width: 25,
      }));

      /*
       * Header formatting
       */

      const headerRow = worksheet.getRow(1);

    headerRow.eachCell((cell) => {
  cell.font = {
    bold: true,
    color: {
      argb: "000000",
    },
  };

  cell.fill = {
    type: "pattern",
    pattern: "solid",
    fgColor: {
      argb: "FFFFFF",
    },
  };

  // cell.alignment = {
  //   vertical: "center",
  //   horizontal: "center",
  //   wrapText: true,
  // };
});
      /*
       * Account-like/text fields should remain text.
       */

      const jobIdColumn = GR_EXPECTED_COLUMNS.indexOf("Job ID") + 1;

      const roadNumberColumn = GR_EXPECTED_COLUMNS.indexOf("Road Number") + 1;

      worksheet.getColumn(jobIdColumn).numFmt = "@";

      worksheet.getColumn(roadNumberColumn).numFmt = "@";

      /*
       * Sample row
       */

      worksheet.addRow({
        "Sr. No.": 1,
        "Administrative Approved Year": "2026-2027",
        District: "पुणे उत्तर",

        Taluka: "हवेली",
        "Work Name":
          "ग्रामीण भागाचा सर्वांगीण विकास करण्यासाठी ग्रामपंचायत, जिल्हा परिषद आणि विविध सरकारी योजनांमार्फत",
        "Work Amount": 10000,
        "Class Of Work": "A",

        "Job ID": "123456789",

        "GR Date": "29-09-2026",

        "GR Number": "GR-2026-001",

        "Head Code": getAllowedHeadCode(),

        "Constituency Name": "Pune",

        "Multiple Gram Panchayat?": "No",

        "Type of Work":
          "रस्ते 'वाहतुकी योग्य' स्थितीत राखण्याची कामे (सर्वसाधारण दुरुस्ती)",

        "Road Category": "Other District Road",

        "Road Number": "12",

        "Proposed Length (KM)": 2.5,

        "Gram Panchayat": "Loni Kalbhor",

        Remark: "Sample Remark",

        "Proposal File Number": "PFN/2026/001",

        "Proposal Date": "29-09-2026",
      });

      /*
       * Sample second row
       */

      worksheet.addRow({
        "Sr. No.": 2,
        "Administrative Approved Year": "2026-2027",
        District: "पुणे दक्षिण",

        Taluka: "हवेली",
        "Work Name":
          "पंचायत समिती स्तरावर गट विकास",
        "Work Amount": 500,

        "Class Of Work": "B",

        "Job ID": "123456789",

        "GR Date": "29-09-2026",

        "GR Number": "GR-2026-001",

        "Head Code": getAllowedHeadCode(),

        "Constituency Name": "Pune",

        "Multiple Gram Panchayat?": "No",

        "Type of Work":
          "रस्ते 'वाहतुकी योग्य",

        "Road Category": "Other District Road",

        "Road Number": "102",

        "Proposed Length (KM)": 8.5,

        "Gram Panchayat": "Loni Kalbhor",

        Remark: "Sample Remark",

        "Proposal File Number": "PFN/2026/001",

        "Proposal Date": "29-09-2026",
      });


      /*
       * Date columns as text
       */

      const dateColumns = ["GR Date", "Proposal Date"];

      dateColumns.forEach((column) => {
        const columnNumber = GR_EXPECTED_COLUMNS.indexOf(column) + 1;

        worksheet.getColumn(columnNumber).numFmt = "@";
      });

      /*
       * Money formatting
       */

      const amountColumn = GR_EXPECTED_COLUMNS.indexOf("Work Amount") + 1;

      worksheet.getColumn(amountColumn).numFmt = "#,##0.00";

      /*
       * Highlight ONLY mandatory columns
       */

      const mandatoryColumns = GR_MANDATORY_COLUMNS;

      // mandatoryColumns.forEach((column) => {
      //   const columnIndex = GR_EXPECTED_COLUMNS.indexOf(column) + 1;

      //   worksheet.getRow(1).getCell(columnIndex).fill = {
      //     type: "pattern",
      //     pattern: "solid",
      //     fgColor: {
      //       argb: "FFF2CC",
      //     },
      //   };

      //   worksheet.getRow(1).getCell(columnIndex).font = {
      //     bold: true,
      //     color: {
      //       argb: "000000",
      //     },
      //   };
      // });

      /*
       * Freeze header
       */

      // worksheet.views = [
      //   {
      //     state: "frozen",
      //     ySplit: 1,
      //   },
      // ];

      /*
       * Auto filter
       */

      worksheet.autoFilter = {
        from: "A1",
        to: `${String.fromCharCode(64 + GR_EXPECTED_COLUMNS.length)}1`,
      };

      const buffer = await workbook.xlsx.writeBuffer();

      saveAs(new Blob([buffer]), "GR_Proposal_Sample.xlsx");
    } catch (error) {
      console.error("Sample Excel generation error:", error);

      alert("Unable to generate sample Excel.");
    }
  };

  /*
   * ---------------------------------------------------------
   * EXCEL UPLOAD
   * ---------------------------------------------------------
   */


  const handleFileUpload = (event) => {
    const file = event.target.files?.[0];

    if (!file) return;

    setUploadError("");

    /*
     * Validate extension
     */

    const extension = file.name.split(".").pop()?.toLowerCase();

    if (extension !== "xlsx" && extension !== "xls") {
      alert("Please upload only .xls or .xlsx Excel file.");

      event.target.value = "";
      return;
    }

    setSelectedFile(file);

    const reader = new FileReader();

    reader.onload = (evt) => {
      try {
        const workbook = XLSX.read(evt.target.result, {
          type: "binary",
          cellDates: true,
        });

        if (!workbook.SheetNames || workbook.SheetNames.length === 0) {
          alert("Excel file contains no sheets.");
          return;
        }

        const sheet = workbook.Sheets[workbook.SheetNames[0]];

        /*
         * Read as array of arrays.
         */

        const rawRows = XLSX.utils.sheet_to_json(sheet, {
          header: 1,
          defval: "",
          raw: true,
        });

        /*
         * -----------------------------------------------------
         * FIND ACTUAL HEADER ROW
         *
         * IMPORTANT:
         * Sr. No. is NOT mandatory anymore.
         *
         * Header row is detected using all 9
         * mandatory columns.
         * -----------------------------------------------------
         */

        const headerRowIndex = rawRows.findIndex((row) => {
          const rowHeaders = row.map((cell) => String(cell).trim());

          return GR_MANDATORY_COLUMNS.every((column) =>
            rowHeaders.includes(column),
          );
        });

        if (headerRowIndex === -1) {
          alert(
            "Could not find all mandatory columns:\n\n" +
              GR_MANDATORY_COLUMNS.join("\n"),
          );

          return;
        }

        /*
         * Get headers.
         */

        const headers = rawRows[headerRowIndex].map((header) =>
          String(header).trim(),
        );

        /*
         * Check duplicate columns.
         */

        const duplicateHeaders = headers.filter(
          (header, index) => header && headers.indexOf(header) !== index,
        );

        if (duplicateHeaders.length > 0) {
          alert(
            "Duplicate columns found:\n\n" +
              [...new Set(duplicateHeaders)].join("\n"),
          );

          return;
        }

        /*
         * -----------------------------------------------------
         * REQUIRED COLUMNS
         *
         * ONLY 9 MANDATORY COLUMNS
         * -----------------------------------------------------
         */

        const missingColumns = GR_MANDATORY_COLUMNS.filter(
          (column) => !headers.includes(column),
        );

        if (missingColumns.length > 0) {
          alert("Missing Mandatory Columns:\n\n" + missingColumns.join("\n"));

          return;
        }

        /*
         * -----------------------------------------------------
         * CONVERT ROWS
         *
         * Sr. No. is NOT required.
         *
         * A row is considered a data row when
         * at least one mandatory field has data.
         * -----------------------------------------------------
         */

        const convertedRows = rawRows
          .slice(headerRowIndex + 1)
          .filter((row) => {
            return GR_MANDATORY_COLUMNS.some((column) => {
              const columnIndex = headers.indexOf(column);

              if (columnIndex === -1) {
                return false;
              }

              const value = row[columnIndex];

              return value !== "" && value !== null && value !== undefined;
            });
          })
          .map((row) => {
            const excelRow = {};

            headers.forEach((header, index) => {
              let value = row[index] ?? "";

              if (header === "GR Date" || header === "Proposal Date") {
                value = formatExcelDate(value);
              }

              if (header === "Gram Panchayat") {
                value = normalizeGramPanchayat(value);
              }

              if (header === "Multiple Gram Panchayat?") {
                value = normalizeMultipleGP(value);
              }

              if (header === "Job ID") {
                value = String(value).trim();

                /*
                 * Avoid scientific notation
                 */

                if (value.includes("E+")) {
                  value = Number(value).toLocaleString("fullwide", {
                    useGrouping: false,
                  });
                }
              }

              excelRow[header] = value;
            });

            return excelRow;
          });

        if (convertedRows.length === 0) {
          alert("No valid GR Proposal rows found in the Excel.");

          return;
        }

        /*
         * -----------------------------------------------------
         * VALIDATE ROWS
         *
         * ONLY 9 FIELDS ARE REQUIRED
         * -----------------------------------------------------
         */

        const errors = [];

        convertedRows.forEach((row, index) => {
          const excelRowNumber = headerRowIndex + index + 2;

          /*
           * Approved Year
           */
          if (!String(row["GR Number"] || "").trim()) {
            errors.push(`Excel Row ${excelRowNumber}: GR Number is required.`);
          }

          if (!String(row["Administrative Approved Year"] || "").trim()) {
            errors.push(
              `Excel Row ${excelRowNumber}: Approved Year is required.`,
            );
          }

          /*
           * Head Code
           */

          // if (!String(row["Head Code"] || "").trim()) {
          //   errors.push(`Excel Row ${excelRowNumber}: Head Code is required.`);
          // }

          /*
           * Role-specific Head Code
           */

          // if (
          //   RoleID &&
          //   String(row["Head Code"] || "").trim() !== getAllowedHeadCode()
          // ) {
          //   errors.push(
          //     `Excel Row ${excelRowNumber}: Head Code does not match the user's allowed Head Code.`,
          //   );
          // }

          /*
           * District
           */

          if (!String(row["District"] || "").trim()) {
            errors.push(`Excel Row ${excelRowNumber}: District is required.`);
          }

          /*
           * Taluka
           */

          if (!String(row["Taluka"] || "").trim()) {
            errors.push(`Excel Row ${excelRowNumber}: Taluka is required.`);
          }

          /*
           * Class Of Work
           */

          if (!String(row["Class Of Work"] || "").trim()) {
            errors.push(
              `Excel Row ${excelRowNumber}: Class Of Work is required.`,
            );
          }

          /*
           * Work Name
           */

          if (!String(row["Work Name"] || "").trim()) {
            errors.push(`Excel Row ${excelRowNumber}: Work Name is required.`);
          }

          /*
           * Job ID
           */

          if (!String(row["Job ID"] || "").trim()) {
            errors.push(`Excel Row ${excelRowNumber}: Job ID is required.`);
          }

          /*
           * GR Date
           */

          if (!row["GR Date"] || !isValidDate(row["GR Date"])) {
            errors.push(`Excel Row ${excelRowNumber}: Invalid GR Date.`);
          }

          /*
           * Work Amount
           */

          const workAmount = row["Work Amount"];

          if (!isValidAmount(workAmount)) {
            errors.push(
              `Excel Row ${excelRowNumber}: Work Amount must contain numbers only.`,
            );
          } else if (Number(workAmount) <= 0) {
            errors.push(
              `Excel Row ${excelRowNumber}: Work Amount must be greater than 0.`,
            );
          }

          /*
           * Future GR Date
           */

          const today = new Date();

          today.setHours(23, 59, 59, 999);

          if (row["GR Date"] && new Date(row["GR Date"]) > today) {
            errors.push(
              `Excel Row ${excelRowNumber}: GR Date cannot be a future date.`,
            );
          }

          /*
           * -------------------------------------------------
           * OPTIONAL FIELDS ARE NOT VALIDATED
           *
           * GR Number
           * Constituency Name
           * Multiple Gram Panchayat?
           * Type of Work
           * Road Category
           * Road Number
           * Proposed Length (KM)
           * Gram Panchayat
           * Remark
           * Proposal File Number
           * Proposal Date
           * -------------------------------------------------
           */
        });

        /*
         * -----------------------------------------------------
         * DUPLICATE WORK VALIDATION
         * -----------------------------------------------------
         */
        /*
 * -----------------------------------------------------
 * SINGLE DISTRICT VALIDATION
 *
 * Only ONE district is allowed in one Excel upload.
 * Example:
 *
 * Pune
 * Pune
 * Pune
 *
 * ✅ Allowed
 *
 * Pune
 * Akola
 * Pune
 *
 * ❌ Not Allowed
 * -----------------------------------------------------
 */

const districtMap = new Map();
const differentDistrictRows = [];

convertedRows.forEach((row, index) => {
  const district = String(row["District"] || "").trim();

  // Empty district is already handled above by required validation
  if (!district) {
    return;
  }

  // Case-insensitive district comparison
  const normalizedDistrict = district.toLowerCase();

  if (!districtMap.has(normalizedDistrict)) {
    districtMap.set(normalizedDistrict, {
      district: district,
      rowIndex: index,
    });
  }
});

/*
 * If more than one unique district is found,
 * reject the complete Excel upload.
 */
if (districtMap.size > 1) {
  const districtDetails = Array.from(districtMap.values())
    .map(
      (item) =>
        `${item.district} (Excel Row ${
          headerRowIndex + item.rowIndex + 2
        })`,
    )
    .join("\n");

  errors.push(
    `Different districts are not allowed in the same Excel upload.\n` +
      `Only one district can be uploaded at a time.\n\n` +
      `Districts found:\n${districtDetails}`,
  );
}
const jobIdMap = new Map();
const duplicateJobIdRows = [];

convertedRows.forEach((row, index) => {
  const jobId = String(row["Job ID"] || "").trim();

  // Skip empty Job ID here.
  // Required-field validation above already handles empty Job ID.
  if (!jobId) {
    return;
  }

  const normalizedJobId = jobId.toLowerCase();

  if (jobIdMap.has(normalizedJobId)) {
    const firstRowIndex = jobIdMap.get(normalizedJobId);

    duplicateJobIdRows.push(
      `Duplicate Job ID "${jobId}" found in Excel Rows ${
        headerRowIndex + firstRowIndex + 2
      } and ${headerRowIndex + index + 2}.`,
    );
  } else {
    jobIdMap.set(normalizedJobId, index);
  }
});

if (duplicateJobIdRows.length > 0) {
  errors.push(...duplicateJobIdRows);
}
        const duplicateRows = [];

        for (let i = 0; i < convertedRows.length; i++) {
          for (let j = i + 1; j < convertedRows.length; j++) {
            const first = convertedRows[i];

            const second = convertedRows[j];

            const same =
              String(first["Work Name"] || "")
                .trim()
                .toLowerCase() ===
                String(second["Work Name"] || "")
                  .trim()
                  .toLowerCase() &&
              String(first["Administrative Approved Year"] || "").trim() ===
                String(second["Administrative Approved Year"] || "").trim() &&
              String(first["Head Code"] || "").trim() ===
                String(second["Head Code"] || "").trim() &&
              String(first["District"] || "").trim() ===
                String(second["District"] || "").trim() &&
              String(first["Taluka"] || "").trim() ===
                String(second["Taluka"] || "").trim() &&
              String(first["Job ID"] || "").trim() ===
                String(second["Job ID"] || "").trim();

            if (same) {
              duplicateRows.push(
                `Rows ${i + 1} and ${j + 1} appear to be duplicate works.`,
              );
            }
          }
        }

        if (duplicateRows.length > 0) {
          errors.push(...duplicateRows);
        }

        /*
         * -----------------------------------------------------
         * SHOW ERRORS
         * -----------------------------------------------------
         */

        if (errors.length > 0) {
          const errorText = errors.slice(0, 50).join("\n");

          setUploadError(errorText);

          alert(
            `Excel validation failed.\n\n${errorText}${
              errors.length > 50 ? "\n\n...and more errors." : ""
            }`,
          );

          return;
        }

        /*
         * -----------------------------------------------------
         * CONVERT EXCEL ROWS TO EXACT BACKEND STRUCTURE
         * -----------------------------------------------------
         */

        const backendRows = convertedRows.map((row) => ({
          GRNumber: String(row["GR Number"] || "").trim(),

          GRDate: formatExcelDate(row["GR Date"]),

          ProposalYear: String(row["Administrative Approved Year"] || "").trim(),

         HeadCode: "3054-2419(Roads and bridge repair maintenance program)",

          District: String(row["District"] || "").trim(),

          Taluka: String(row["Taluka"] || "").trim(),

          ConstituencyName: String(row["Constituency Name"] || "").trim(),

          isMultipleGp: normalizeMultipleGP(row["Multiple Gram Panchayat?"]),

          classOfWork: String(row["Class Of Work"] || "").trim(),

          typeOfWork: String(row["Type of Work"] || "").trim(),

          proposalworkname: String(row["Work Name"] || "").trim(),

          JobId: String(row["Job ID"] || "").trim(),

          roadCategory: String(row["Road Category"] || "").trim(),

          roadNumber: String(row["Road Number"] || "").trim(),

          proposedLength: String(row["Proposed Length (KM)"] ?? "").trim(),

          gramPanchayat: normalizeGramPanchayat(row["Gram Panchayat"]),

          proposalworkamount: String(row["Work Amount"] ?? "").trim(),

          remark: String(row["Remark"] || "").trim(),

          ProposalFileNumber: String(row["Proposal File Number"] || "").trim(),

          proposalDate: formatExcelDate(row["Proposal Date"]),

          GRamount: "",
        }));

        /*
         * Calculate total.
         */

        const total = backendRows.reduce(
          (sum, row) => sum + Number(row.proposalworkamount || 0),
          0,
        );

        /*
         * Set preview.
         */

        setTableData(backendRows);

        setCurrentPage(1);

        setShowAll(false);

        setUploadError("");

        console.log("GR Excel Backend Rows:", backendRows);

        alert(
          `${backendRows.length} GR Proposal row(s) loaded successfully.\n\nTotal Proposal Amount: ₹${total.toLocaleString(
            "en-IN",
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            },
          )}`,
        );
      } catch (error) {
        console.error("Excel processing error:", error);

        setUploadError(error?.message || "Unable to process Excel file.");

        alert(
          "Unable to process the Excel file. Please check the file format.",
        );
      }
    };

    reader.onerror = () => {
      alert("Unable to read the selected Excel file.");
    };

    reader.readAsBinaryString(file);
  };

  /*
   * ---------------------------------------------------------
   * DELETE ROW
   * ---------------------------------------------------------
   */

  const handleDelete = (index) => {
    const actualIndex = indexOfFirst + index;

    const updated = tableData.filter((_, i) => i !== actualIndex);

    setTableData(updated);

    const newTotalPages = Math.ceil(updated.length / BILLS_PER_PAGE);

    if (currentPage > newTotalPages && newTotalPages > 0) {
      setCurrentPage(newTotalPages);
    }
  };

  /*
   * ---------------------------------------------------------
   * CLEAR EXCEL
   * ---------------------------------------------------------
   */

  const handleClear = () => {
    if (tableData.length > 0) {
      const confirmed = window.confirm(
        "Are you sure you want to clear all uploaded GR Proposal rows?",
      );

      if (!confirmed) {
        return;
      }
    }

    setTableData([]);

    setSelectedFile(null);

    setUploadError("");

    setCurrentPage(1);

    setShowAll(false);

    const fileInput = document.getElementById("gr-proposal-excel");

    if (fileInput) {
      fileInput.value = "";
    }
  };

  /*
   * ---------------------------------------------------------
   * TOTAL AMOUNT
   * ---------------------------------------------------------
   */

  const totalAmount = tableData.reduce(
    (sum, row) => sum + Number(row.proposalworkamount || 0),
    0,
  );

  /*
   * ---------------------------------------------------------
   * SUBMIT
   * ---------------------------------------------------------
   */
/*
 * ---------------------------------------------------------
 * GR UPLOAD COPY
 * ---------------------------------------------------------
 */

const handleUploadOrder = (event) => {
  const file = event.target.files?.[0];

  if (!file) {
    setUploadOrderFile(null);
    return;
  }

  const allowedExtensions = ["pdf"];

  const extension = file.name.split(".").pop()?.toLowerCase();

  if (!allowedExtensions.includes(extension)) {
    alert("Please upload only PDF, XLS or XLSX file.");

    event.target.value = "";
    setUploadOrderFile(null);

    return;
  }

  /*
   * Optional file size validation
   * 10 MB maximum
   */
  // const maxSize = 10 * 1024 * 1024;

  // if (file.size > maxSize) {
  //   alert("GR upload copy file size should not exceed 10 MB.");

  //   event.target.value = "";
  //   setUploadOrderFile(null);

  //   return;
  // }

  setUploadOrderFile(file);

  console.log("GR Upload Copy:", file);
};
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (tableData.length === 0) {
      alert("No GR Proposal data found. Please upload Excel first.");

      return;
    }

  if (!uploadOrderFile) {
    alert("Please upload GR upload copy.");
    return;
  }
    const invalidRows = tableData.filter(
      (row) =>
        !row.GRNumber ||
        !row.ProposalYear ||
        !row.GRDate ||
        !row.HeadCode ||
        !row.District ||
        !row.Taluka ||
        !row.classOfWork ||
        !row.proposalworkname ||
        !row.JobId ||
        !row.proposalworkamount,
    );

    if (invalidRows.length > 0) {
      alert(
        `${invalidRows.length} row(s) contain missing mandatory data. Please upload a corrected Excel.`,
      );

      return;
    }

    /*
     * Validate amount again.
     */

    const invalidAmount = tableData.filter(
      (row) =>
        !isValidAmount(row.proposalworkamount) ||
        Number(row.proposalworkamount) <= 0,
    );

    if (invalidAmount.length > 0) {
      alert("One or more rows have an invalid Work Amount.");

      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();

      /*
       * Calculate GR amount for every row
       * based on its GR Number.
       */

      const updatedTable = tableData.map((row) => {
        const totalGRAmount = tableData
          .filter((item) => item.GRNumber === row.GRNumber)
          .reduce((sum, item) => sum + Number(item.proposalworkamount || 0), 0);

        return {
          ...row,
          GRamount: totalGRAmount,
        };
      });

      /*
       * Existing backend payload.
       */

      formData.append("TotalProposalAmount", String(totalAmount));
formData.append("Type", "fileuploadGR");
      formData.append("WorkTableData", JSON.stringify(updatedTable));
   formData.append(
      "GRUploadCopy",
      uploadOrderFile,
    );
formData.append("Type", "fileuploadGR");
const submitHeadCode =
  "3054-2419(Roads and bridge repair maintenance program)";

formData.append("HeadCode", submitHeadCode);

      console.log("Submitting GR Proposal Excel data:", updatedTable);

      const result = await GRProposalCreationFunction(formData);

      console.log("GR Proposal submit response:", result);

      const status = result?.status;

      const message = result?.message;

      if (status) {
        alert(message || "GR Proposal created successfully.");

        setTableData([]);

        setSelectedFile(null);

        setCurrentPage(1);

        setShowAll(false);

        const fileInput = document.getElementById("gr-proposal-excel");

        if (fileInput) {
          fileInput.value = "";
        }

        window.location.reload();
      } else {
        alert(
          message ||
            (typeof result === "string"
              ? result
              : "GR Proposal submission failed."),
        );
      }
    } catch (error) {
      console.error("GR Proposal submission error:", error);

      alert("Error while submitting GR Proposal.");
    } finally {
      setLoading(false);
    }
  };


  /*
   * ---------------------------------------------------------
   * FORMAT PREVIEW VALUE
   * ---------------------------------------------------------
   */

  const getPreviewValue = (row, column) => {
    switch (column) {
      case "GR Number":
        return row.GRNumber;

      case "Administrative Approved Year":
        return row.ProposalYear;

      case "Head Code":
        return row.HeadCode;

      case "District":
        return row.District;

      case "Taluka":
        return row.Taluka;

      case "Constituency Name":
        return row.ConstituencyName;

      case "Multiple Gram Panchayat?":
        return row.isMultipleGp;

      case "Class Of Work":
        return row.classOfWork;

      case "Type of Work":
        return row.typeOfWork;

      case "Work Name":
        return row.proposalworkname;

      case "Job ID":
        return row.JobId;

      case "Road Category":
        return row.roadCategory;

      case "Road Number":
        return row.roadNumber;

      case "Proposed Length (KM)":
        return row.proposedLength;

      case "Gram Panchayat":
        return Array.isArray(row.gramPanchayat)
          ? row.gramPanchayat.join(", ")
          : row.gramPanchayat;

      case "Work Amount":
        return `₹${Number(row.proposalworkamount || 0).toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;

      case "Remark":
        return row.remark;

      case "Proposal File Number":
        return row.ProposalFileNumber;

      case "Proposal Date":
        return row.proposalDate;

      case "GR Date":
return new Date(row.GRDate).toLocaleDateString("en-IN");
      default:
        return "";
    }
  };

  /*
   * ---------------------------------------------------------
   * UI
   *
   * KEPT SAME AS YOUR ORIGINAL UI
   * ---------------------------------------------------------
   */

  const GR_PREVIEW_COLUMNS = GR_EXPECTED_COLUMNS.filter(
    (column) => column !== "Sr. No.",
  );

  return (
    <div
      className="col-12"
      style={{
        height: "91vh",
        overflowY: "auto",
        backgroundColor: "#EFF3F8",
        paddingBottom: "40px",
      }}
    >
      <div
        className="col-12"
        style={{
          padding: "2px 0px 5px 0px",
        }}
      >
        <div
          className="col-12 m-auto my-5 budgetContainer19"
          style={{
            paddingBottom: "30px",
          }}
        >
          <div className="m-auto budgetElement">
            {/* HEADER */}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "15px 20px",
                borderBottom: "1px solid #e4e8ec",
              }}
            >
              <div>
                <h5
                  style={{
                    margin: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  <img src={ProposalCreation32} alt="GR Proposal" />

                  {t("Create GR Proposal")}
                </h5>
              </div>
              {/* GR UPLOAD COPY */}

<div
  style={{
    margin: "0 20px 20px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "15px",
    background: "#f8fafc",
    borderRadius: "10px",
    border: "1px solid #dbe4ee",
    flexWrap: "wrap",
  }}
>
  <label
    style={{
      fontSize: "15px",
      fontWeight: "600",
      color: "#1e293b",
      margin: 0,
    }}
  >
    {t("GR upload copy")}
    <span
      style={{
        color: "red",
      }}
    >
      {" "}
      *
    </span>
  </label>

  <input
    type="file"
    accept=".pdf"
    onChange={handleUploadOrder}
    style={{
      border: "1px solid #cbd5e1",
      padding: "8px",
      borderRadius: "6px",
      background: "white",
      fontSize: "13px",
      cursor: "pointer",
    }}
  />

  {uploadOrderFile && (
    <span
      style={{
        fontSize: "13px",
        color: "#0f172a",
        fontWeight: "500",
      }}
    >
      Selected: {uploadOrderFile.name}
    </span>
  )}
</div>
            </div>

            {/* LOADER */}

            {loading && (
              <div
                style={{
                  position: "fixed",
                  inset: 0,
                  background: "rgba(255,255,255,0.7)",
                  backdropFilter: "blur(4px)",
                  zIndex: 9999,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{
                    border: "6px solid #f3f3f3",
                    borderTop: "6px solid #007bff",
                    borderRadius: "50%",
                    width: "60px",
                    height: "60px",
                    animation: "spin 1s linear infinite",
                  }}
                />
              </div>
            )}

            {/* SAMPLE DOWNLOAD */}

            <div
              style={{
                margin: "0 20px 15px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "10px",
              }}
            >
              <button
                type="button"
                onClick={downloadSampleExcel}
                style={{
                  border: "none",
                  background: "transparent",
                  color: "#007bff",
                  cursor: "pointer",
                  fontWeight: "600",
                  textDecoration: "underline",
                  fontSize: "14px",
                }}
              >
                Download GR Proposal Sample Excel
              </button>
            </div>

            {/* FILE UPLOAD */}

            <div
              style={{
                margin: "0 20px 20px",
                padding: "20px",
                background: "#ffffff",
                border: "1px solid #dfe5eb",
                borderRadius: "8px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
              }}
            >
              <label
                style={{
                  display: "block",
                  fontWeight: "600",
                  marginBottom: "8px",
                }}
              >
                Upload GR Proposal Excel
                <span
                  style={{
                    color: "red",
                  }}
                >
                  {" "}
                  *
                </span>
              </label>

              <input
                id="gr-proposal-excel"
                type="file"
                accept=".xls,.xlsx"
                className="form-control"
                onChange={handleFileUpload}
              />

              {selectedFile && (
                <div
                  style={{
                    marginTop: "8px",
                    fontSize: "13px",
                    color: "#555",
                  }}
                >
                  Selected File: <strong>{selectedFile.name}</strong>
                </div>
              )}
            </div>

            {/* ERROR */}

            {uploadError && (
              <div
                style={{
                  margin: "0 20px 20px",
                  padding: "15px",
                  background: "#fff0f0",
                  border: "1px solid #f1b8b8",
                  borderRadius: "6px",
                  color: "#b60101",
                  whiteSpace: "pre-wrap",
                  fontSize: "13px",
                  maxHeight: "250px",
                  overflowY: "auto",
                }}
              >
                <strong>Excel Validation Error</strong>

                <div
                  style={{
                    marginTop: "8px",
                  }}
                >
                  {uploadError}
                </div>
              </div>
            )}

            {/* PREVIEW */}

            {tableData.length > 0 && (
              <div
                style={{
                  margin: "0 20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "10px",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <h6
                    style={{
                      margin: 0,
                      fontWeight: "700",
                    }}
                  >
                    Excel Preview
                  </h6>

                  <button
                    type="button"
                    onClick={handleClear}
                    style={{
                      border: "none",
                      background: "#dc3545",
                      color: "#fff",
                      borderRadius: "4px",
                      padding: "7px 14px",
                      cursor: "pointer",
                      fontWeight: "600",
                    }}
                  >
                    Clear Excel
                  </button>
                </div>

                <div
                  style={{
                    background: "white",
                    boxShadow: "0px 0px 5px 1px #E4E8EC",
                    width: "100%",
                    overflow: "hidden",
                    borderRadius: "6px",
                    border: "1px solid #ddd",
                  }}
                >
                  <div
                    style={{
                      maxHeight: "500px",
                      overflowY: "auto",
                      overflowX: "auto",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "13px",
                        minWidth: "2800px",
                      }}
                    >
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 2,
                        }}
                      >
                        <tr
                          style={{
                            background: "#2C78DB",
                            color: "white",
                          }}
                        >
                          <th
                            style={{
                              padding: "9px",
                              border: "1px solid #ddd",
                              minWidth: "55px",
                            }}
                          >
                            Sr.No
                          </th>

                          {GR_PREVIEW_COLUMNS.map((column) => (
                            <th
                              key={column}
                              style={{
                                padding: "9px",
                                border: "1px solid #ddd",
                                minWidth:
                                  column === "Work Name" ? "250px" : "160px",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {column}
                            </th>
                          ))}

                          <th
                            style={{
                              padding: "9px",
                              border: "1px solid #ddd",
                              minWidth: "90px",
                            }}
                          >
                            Action
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentRows.map((row, index) => (
                          <tr
                            key={index}
                            style={{
                              backgroundColor:
                                index % 2 === 0 ? "#E5F4FB" : "#ffffff",
                            }}
                          >
                            <td
                              style={{
                                padding: "7px",
                                border: "1px solid #ddd",
                                textAlign: "center",
                                fontWeight: "600",
                              }}
                            >
                              {indexOfFirst + index + 1}
                            </td>

                            {GR_PREVIEW_COLUMNS.map((column) => (
                              <td
                                key={column}
                                style={{
                                  padding: "7px 10px",
                                  border: "1px solid #ddd",
                                  whiteSpace:
                                    column === "Work Name" ||
                                    column === "Gram Panchayat" ||
                                    column === "Remark"
                                      ? "normal"
                                      : "nowrap",
                                  maxWidth:
                                    column === "Work Name"
                                      ? "300px"
                                      : undefined,
                                  wordBreak: "break-word",
                                }}
                              >
                                {getPreviewValue(row, column)}
                              </td>
                            ))}

                            <td
                              style={{
                                padding: "7px",
                                border: "1px solid #ddd",
                                textAlign: "center",
                              }}
                            >
                              <button
                                type="button"
                                onClick={() => handleDelete(index)}
                                style={{
                                  background: "#dc3545",
                                  color: "#fff",
                                  border: "none",
                                  borderRadius: "4px",
                                  padding: "5px 10px",
                                  cursor: "pointer",
                                }}
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* PAGINATION */}

                <div
                  style={{
                    marginTop: "15px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexWrap: "wrap",
                    gap: "10px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#555",
                    }}
                  >
                    Showing {indexOfFirst + 1} to{" "}
                    {Math.min(indexOfLast, tableData.length)} of{" "}
                    {tableData.length} entries
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <GooglePagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={setCurrentPage}
                    />

                    <button
                      type="button"
                      onClick={() => {
                        setShowAll(!showAll);

                        setCurrentPage(1);
                      }}
                      style={{
                        border: "none",
                        outline: "none",
                        cursor: "pointer",
                        padding: "8px 16px",
                        borderRadius: "20px",
                        fontSize: "13px",
                        fontWeight: "600",
                        color: "#fff",
                        background: showAll
                          ? "linear-gradient(135deg, #28a745, #20c997)"
                          : "linear-gradient(135deg, #0067ab, #0098d5)",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                      }}
                    >
                      {showAll ? "✓ Showing All" : "View All"}
                    </button>
                  </div>
                </div>

                {/* SUBMIT */}

                <div
                  style={{
                    marginTop: "25px",
                    marginBottom: "20px",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                  }}
                >
                  <button
                    type="button"
                    onClick={handleClear}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "5px",
                      background: "#f1594c",
                      color: "#fff",
                      width: "100px",
                      height: "38px",
                      fontSize: "14px",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    Clear
                  </button>

                  <button
                    type="button"
                    onClick={handleSubmit}
                    disabled={loading || tableData.length === 0}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "5px",
                      background:
                        tableData.length > 0
                          ? "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)"
                          : "#999",
                      color: "white",
                      width: "120px",
                      height: "38px",
                      fontSize: "16px",
                      border: "none",
                      borderRadius: "5px",
                      cursor: tableData.length > 0 ? "pointer" : "not-allowed",
                    }}
                  >
                    <img
                      src={submit}
                      alt="submit"
                      style={{
                        width: "15px",
                      }}
                    />
                    Save
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <style>
        {`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }

            100% {
              transform: rotate(360deg);
            }
          }

          .budgetElement {
            width: 100%;
          }

          table th {
            vertical-align: middle;
          }

          table td {
            vertical-align: middle;
          }

          input[type="file"] {
            cursor: pointer;
          }
        `}
      </style>
    </div>
  );
};

export default UploadGRProposalCreation;
